<template lang="pug">
    .quares(v-if="(contents && contents.length)" ref="container" :style="style")
        Square(v-for="content in contents" :key="content.id" :square="content")
</template>

<script>
import _ from 'lodash'

import Square from './Square'

export default {
    name: 'Squares',
    data() {
        return {
            width: undefined
        }
    },
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        Square
    },
    computed: {
        contents() {
            let contents = this.section.contents || []
            return _.cloneDeep(contents).sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))
        },
        style() {
            let rows = 1
            let columns = this.contents.length
            let justify = 'space-between'

            if (this.width <= 450 && this.contents.length === 3) {
                rows = 2
                columns = 2
            }

            if (this.width <= 650 && this.contents.length === 4) {
                rows = 2
                columns = 2
            }

            if (this.width <= 325 && this.contents.length > 1) {
                rows = this.contents.length
                columns = 1
                justify = 'center'
            }

            const width = Math.min(this.width / columns, 300)

            return {
                'grid-template-rows': `repeat(${rows}, ${width}px)`,
                'grid-template-columns': `repeat(${columns}, ${width}px)`,
                'justify-content': justify
            }
        },
    },
    mounted() {
        const calculateDimensions = () => {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container)
                this.width = this.$refs.container.offsetWidth
                this.width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
                this.width -= (this.contents.length - 1) * 10
            }
        }

        window.addEventListener('resize', _.debounce(calculateDimensions, 100))
        calculateDimensions()
    }
}
</script>

<style lang="sass" scoped>

.quares
    display: grid
    gap: 10px
    color: white
    margin-top: 2rem
</style>
